(
    function (skyward, $)
    {
        skyward.cashreceiptselector = skyward.cashreceiptselector || {};

        skyward.cashreceiptselector.resetwaitingmessage = function ()
        {
            var waitingMessageSubject = $('#editCashReceiptRequest_CashReceiptRequestWaitingMessageSubject');
            var waitingMessageContent = $('#editCashReceiptRequest_CashReceiptRequestWaitingMessageContent');
            var defaultWaitingMessageSubject = 'Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} is waiting for your approval';
            var defaultWaitingMessageContent = '{User.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} is waiting for your approval at {TaskInstance.CashReceiptApproval.LevelDescription}.';

            skyward.controls.setValue(waitingMessageSubject, defaultWaitingMessageSubject, false);
            skyward.controls.setValue(waitingMessageContent, defaultWaitingMessageContent, false);
        }

        skyward.cashreceiptselector.resetapprovedmessage = function ()
        {
            var approvedMessageSubject = $('#editCashReceiptRequest_CashReceiptRequestApprovedMessageSubject');
            var approvedMessageContent = $('#editCashReceiptRequest_CashReceiptRequestApprovedMessageContent');
            var defaultApprovedMessageSubject = 'Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} has been approved';
            var defaultApprovedMessageContent = '{CashReceiptDeposit.UserCreatedBy.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} has been approved at {TaskInstance.CashReceiptApproval.LevelDescription}.';

            skyward.controls.setValue(approvedMessageSubject, defaultApprovedMessageSubject, false);
            skyward.controls.setValue(approvedMessageContent, defaultApprovedMessageContent, false);
        }

        skyward.cashreceiptselector.resetdeniedmessage = function ()
        {
            var deniedMessageSubject = $('#editCashReceiptRequest_CashReceiptRequestDeniedMessageSubject');
            var deniedMessageContent = $('#editCashReceiptRequest_CashReceiptRequestDeniedMessageContent');
            var defaultDeniedMessageSubject = 'Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} has been denied';
            var defaultDeniedMessageContent = '{CashReceiptDeposit.UserCreatedBy.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} has been denied at {TaskInstance.CashReceiptApproval.LevelDescription}.\n\nDenial Reason: {Comment}';

            skyward.controls.setValue(deniedMessageSubject, defaultDeniedMessageSubject, false);
            skyward.controls.setValue(deniedMessageContent, defaultDeniedMessageContent, false);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);